define('views/invite/featuredcause',["backbone",
        "text!views/invite/featuredcause.html",        
        "views/_base/baseview"
], function (Backbone, Template, BaseView) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        isRender: true,
        needsAuth: true,
        scrollToTop: false,
        tagName: "section",
        className: "miniCard",
        events: {
            "click #btnFeaturedCauseJoin": "joinCause",
            "click #bntFeaturedCauseLeave": "unjoinCause"
        },
        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function () {

            this.$el.html(this.template({ data: this.model.toJSON() }));

            var that = this;
            this.$("#bntFeaturedCauseParticipant").mouseenter(function (e) { that.changeOptions(e); });
            this.$("#bntFeaturedCauseLeave").mouseleave(function (e) { that.changeOptions(e); });

            return this;
        },
        loadData: function () {
        },
        joinCause: function () {

            var data = this.model.toJSON();

            var that = this;
            $.ajax({
                type: 'GET',
                async: false,
                url: pf.accountsURL + "/" + data.accountGUID + "/Join",
                success: function () {
                    if (data.ApprovalRequired)
                        that.$("#btnFeaturedCauseJoin").replaceWith(enums.htmlTags.RequestPending);
                    else {
                        that.changeOptions(null, 'btnFeaturedCauseJoin');
                    }
                    that.delegateEvents();
                },
                error: function (resp) {
                    pfdialog.error({
                        context: that,
                        okButtonText: "Ok",
                        Title: "Error",
                        Body: "Failed to join the Cause... please check back later"
                    });
                }
            });

        },
        unjoinCause: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }
            var that = this
            var data = that.model.toJSON();

            if (data.accountGUID != null && data.accountGUID != undefined) {
                var participantStatusID = pf.enums.participantStatusTypeEnum.Unjoined;
                var url = pf.accountsURL + "/" + data.accountGUID + "/" + participantStatusID + "/UpdParticipant";
                $.ajax({
                    type: "POST",
                    url: url,
                    contentType: "application/json",
                    async: false,
                    success: function (response) {
                        if (response) {                            
                        }
                        that.changeOptions(null,'join');
                    },
                    error: function (response) {
                    }
                });
            }
        },
        changeOptions: function (e,selector) {

            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;
            if (selector)
                var current = selector;
            else
                var current = e.target.id;
            switch (current) {
                case "bntFeaturedCauseParticipant":
                    this.$("#bntFeaturedCauseParticipant").replaceWith(enums.htmlTags.FeaturedCauseLeave);
                    break;
                case "bntFeaturedCauseLeave":
                    this.$("#bntFeaturedCauseLeave").replaceWith(enums.htmlTags.FeaturedCauseParticipant);
                    break;
                case "btnFeaturedCauseJoin":
                    this.$("#btnFeaturedCauseJoin").replaceWith(enums.htmlTags.FeaturedCauseParticipant);
                    break;
                default:
                    this.$("#bntFeaturedCauseLeave").replaceWith(enums.htmlTags.FeaturedCauseJoin);
                    this.$("#bntFeaturedCauseParticipant").replaceWith(enums.htmlTags.FeaturedCauseJoin);
                    break;

            }
            this.$("#bntFeaturedCauseParticipant").mouseenter(function (e) { that.changeOptions(e); });
            this.$("#bntFeaturedCauseLeave").mouseleave(function (e) { that.changeOptions(e); });
            this.delegateEvents();
        },
        close: function () {
        }
    });
});

